export default __webpack_public_path__ + "static/media/PlusCircle (1).f674121c.svg";